import React from 'react';

// Components
import DeleteUser from './DeleteUser';

const UserActions = ({ deleteUser }) => (
  <div className="admin-profile-card-actions">
    <DeleteUser deleteUser={deleteUser} />
  </div>
)

export default UserActions;



// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserActions.js